import { hot } from 'react-hot-loader/root';
import React from 'react';
import '../../tiled-header';
import '@updater-components/cta';
import './next-step.global.css';
import debounce from 'lodash-es/debounce';

const height = 86;
const isSmallScreen = window.matchMedia('(max-width: 450px)');
const calculateScroll = ({ bottom, top: previousTop, newTop, size }) => {
  const scrollDistance = previousTop - newTop;
  let newBottom = bottom + scrollDistance;
  if (newBottom > 0) {
    newBottom = 0;
  } else if (newBottom < -1 * size) {
    newBottom = -1 * size;
  }

  return {
    bottom: newBottom,
    top: newTop,
  };
};

function Elem({ onNext, onGoHome, isOnLastStep }) {
  const [{ bottom, top }, setState] = React.useState({ bottom: 0, top: 0 });

  React.useLayoutEffect(() => {
    const handleScroll = debounce(({ target: { scrollingElement } }) => {
      const newTop = scrollingElement.scrollTop;
      setState(calculateScroll({ bottom, top, newTop, size: height }));
    }, 10);
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [bottom, top]);

  return (
    <div
      className="app-footer"
      style={{
        bottom: `${bottom}px`,
        visibility: bottom === -1 * height ? 'hidden' : 'visible',
      }}
    >
      <upd-tiled-header>
        <div className="app-footer-buttons">
          {!isSmallScreen.matches && !isOnLastStep && (
            <a onClick={onGoHome}>Go to home</a>
          )}
          {!isOnLastStep && (
            <upd-cta secondary>
              <a onClick={onNext}>Start Next Task</a>
            </upd-cta>
          )}
          {isOnLastStep && (
            <upd-cta secondary>
              <a onClick={onGoHome}>Go to home</a>
            </upd-cta>
          )}
        </div>
      </upd-tiled-header>
    </div>
  );
}

export const Footer = hot(Elem);
